import find from "lodash/find";
import { Card } from "PFComponents/card";
import { Tabs, TabsVariant } from "PFComponents/tabs";
import { TabVariant } from "PFComponents/tabs/tabs.types";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { Profile } from "PFTypes";

import { NavSection } from "../profile_edit_sections.types";

type ProfileEditNavProps = {
  currentSection: string;
  sections: NavSection[];
  adminPage?: boolean;
  profile: Profile;
};

const ProfileEditNav = ({ currentSection, sections, adminPage, profile }: ProfileEditNavProps) => {
  const isEnabled = useIsFeatureEnabled();

  const visibleSections = sections.filter(
    ({ requireFeature, isVisible }) =>
      (!requireFeature || isEnabled(requireFeature)) && (!isVisible || isVisible())
  );

  const tabs = visibleSections.map(({ section, text, onClick, icon, danger, qaId }) => ({
    id: section,
    title: text,
    href: onClick
      ? undefined
      : adminPage
        ? `/admin/users/${profile.id}/edit/${section}`
        : `/profile/edit/${section}`,
    icon,
    variant: danger ? TabVariant.Danger : TabVariant.Default,
    ddActionName: qaId
  }));

  const handleChange = (id: string) => {
    find(visibleSections, { section: id })?.onClick?.();
  };

  return (
    <Card>
      <Tabs tabs={tabs} activeTab={currentSection} variant={TabsVariant.Vertical} onChange={handleChange} />
    </Card>
  );
};

export default ProfileEditNav;
